import React from "react";
import { RotatingLines } from "react-loader-spinner";

const Loader = () => {
  return (
    <div className="flex items-center justify-center h-[calc(100vh-6rem)]">
      <div className="flex space-x-2">
        <RotatingLines
              strokeColor="#578E7E"
              strokeWidth="5"
              animationDuration="1"
              width="96"
              visible={true}
            />
      </div>
    </div>
  );
};

export default Loader;
